import {Component, OnInit} from '@angular/core';
import {LoginService} from "./login.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {HeaderService} from "../header/header.service";
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'pbc-login',
  templateUrl: './login.component.html'
})
export class  LoginComponent implements OnInit {

  loginForm: FormGroup;
  error: boolean = false;
  private querySharedReportId: string;
  private queryReportId: string;

  constructor(
      private loginService: LoginService,
      private headerService: HeaderService,
      private router: Router,
      private activatedRoute : ActivatedRoute,) {
  }

  onSubmit() {
      this.loginService.login(this.loginForm.controls['email'].value,
                              this.loginForm.controls['password'].value,
                              this.querySharedReportId,
                              this.queryReportId)
      .subscribe(
      (response) => {
        this.error = false;
      },
      (error) => {
        this.error = true;
      }
    );
  }

  ngOnInit() {
    this.getReportIdParams();
    this.loginForm = new FormGroup({
      'email' : new FormControl('', [Validators.required, Validators.email]),
      'password' : new FormControl('', Validators.required),
      'remember' : new FormControl(true)
    });

    this.headerService.isHomepage(false);

    this.loginForm = new FormGroup({
      'email' : new FormControl('', [Validators.required, Validators.email]),
      'password' : new FormControl('', Validators.required),
      'remember' : new FormControl(true)
    });
  }

  private getReportIdParams() {
    this.activatedRoute.params.subscribe(queryParams => {
      this.querySharedReportId = queryParams['sharedReportId'];
      this.queryReportId = queryParams['singleReportId'];
    });


  }

  resetPasswordClick() {
    this.router.navigate(['reset-password']);
  }
}
